import { Loader2 } from 'lucide-react'

interface PublishBarProps {
  onPublish: () => void
  onCancel: () => void
  isPublishing: boolean
}

export function PublishBar({ onPublish, onCancel, isPublishing }: PublishBarProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 flex h-16 items-center justify-end gap-3 border-t border-gray-200 bg-white px-6 shadow-lg">
      <button
        type="button"
        onClick={onCancel}
        disabled={isPublishing}
        className="rounded-md px-4 py-2 text-sm text-gray-600 transition-colors motion-reduce:transition-none hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      >
        ยกเลิก
      </button>
      <button
        type="button"
        onClick={onPublish}
        disabled={isPublishing}
        className="flex items-center gap-2 rounded-sm bg-blue-600 px-5 py-2 text-sm font-semibold text-white transition-colors motion-reduce:transition-none hover:bg-blue-700 disabled:opacity-70 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      >
        {isPublishing && <Loader2 className="h-4 w-4 animate-spin" />}
        {isPublishing ? 'กำลังบันทึก...' : 'เผยแพร่'}
      </button>
    </div>
  )
}
